import { render } from "./chevronFixed.vue?vue&type=template&id=61bcbd41&scoped=true&ts=true"
import script from "./chevronFixed.vue?vue&type=script&lang=ts"
export * from "./chevronFixed.vue?vue&type=script&lang=ts"

import "./chevronFixed.vue?vue&type=style&index=0&id=61bcbd41&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bcbd41"]])

export default __exports__